<template>
    <div class='info-service-page' id="infoService">
      <header-common @popupHandle="popupHandle" :isFixed="isFixed"></header-common>
      <div class="main-content">
          <van-popup v-model="showPopup" position="right" :style="{ width:'150px',height:'100%',paddingTop:'120px'}">
              <el-menu
                  :default-active="'name_'+$route.query.id"
                  class="el-menu-vertical-demo"
                  :unique-opened="true"
                  @select="handleSelect">
                  <el-submenu :index="'typeName_'+index" v-for="(item, index) in typeNameList" :key="'typeName_'+index">
                      <template slot="title">
                          <span>{{item.name}}</span>
                      </template>
                      <el-menu-item
                          v-for="(list,i) in item.list"
                          :key="'typeName_'+index+'_'+i"
                          :index="'name_'+list.id"><div>{{list.value}}</div></el-menu-item>
                  </el-submenu>
              </el-menu>
          </van-popup>
          <!--new-->
          <div class="info-service-nav" :class="!isShowAll? 'service-nav-overflow': ''" :style="isShowAll? {'box-shadow': '3px 3px 5px rgba(100, 100, 100,0.2)'}: {}" v-if="screenWidth >=1200">
              <div class="type-list-content">
                  <div class="type-list" v-for="(item, index) in typeNameList" :key="'typeName_'+index" @mouseenter="mouseenterHandle" @mouseleave="mouseleaveHandle">
                      <div class="type-list-title" :class="listTitleStyle(item.list)">{{item.name}}</div>
                      <ul class="type-list-ul">
                          <li class="type-list-li"
                              v-for="(list, i) in item.list"
                              :key="'typeName_'+index+'_'+i"
                              :class="list.id == $route.query.id ? 'active': '' "
                              @click="handleClick(list.id)">{{list.value}}</li>
                      </ul>
                  </div>
              </div>
              <div class="unfold" :style="isShowAll? {'top': '15px'}:{'top':'15px'}"  @click="menuClick">
                  <div class="icon-font" :class="isShowAll?'up': 'down'"></div>
                  <!--<i class="el-icon" :class="isShowAll ? 'el-icon-arrow-up': 'el-icon-arrow-down'"></i>-->
              </div>
          </div>
          <div class="display" v-if="screenWidth >=1200">
              <div class="title">
                  <div class="name">{{ itemList[currentId].title}}</div>
                  <div class="desc">
                      {{itemList[currentId].description}}
                  </div>
              </div>
              <div class="img">
                  <img :src="itemList[currentId].imgUrl">
              </div>
              <div class="clear"></div>
          </div>
          <div class="display" v-else>
              <div class="img">
                  <img :src="itemList[currentId].imgUrl">
              </div>
              <div class="title">
                  <div class="name">{{ itemList[currentId].title}}</div>
                  <div class="desc">
                      {{itemList[currentId].description}}
                  </div>
              </div>
          </div>
          <div class="key-word" v-if="$route.query.id == 16">
              制度可进行分类，实行多版本管理，可展示制度修订历程
          </div>
          <div class="key-word" v-if="$route.query.id == 17">
              多班次排班，室内精准定位，自动考勤打卡，统计分析
          </div>
          <div class="key-word" v-if="$route.query.id == 18">
              输入关键字即可检索项目、任务、会议、需求、资料、知识库等数据,还可检索附件内容，全面检索无遗漏。
          </div>
          <div class="list-show"  v-if="screenWidth >=1200">
              <div class="list" v-for="(item, index) in itemList[currentId].content" :key="'list_'+index">
                  <div class="right" v-if="!($route.query.id == 18 || $route.query.id == 17 || $route.query.id == 16)">
                      <div class="name">{{item.title}}</div>
                      <div class="desc">
                          <div v-for="(label, index) in item.description" :key="'name_'+currentId+'_'+index">{{label}}</div>
                      </div>
                  </div>
                  <div class="left" :style="$route.query.id == 16 || $route.query.id ==17 || $route.query.id==18 ? {'width':'100%'}: {}">
                      <img :src="item.imgUrl">
                  </div>
                  <div class="clear"></div>
              </div>
          </div>
          <div class="list-show"  v-else>
              <div class="list" v-for="(item, index) in itemList[currentId].content" :key="'list_'+index">
                  <div class="left" :style="$route.query.id == 16 || $route.query.id ==17 || $route.query.id==18 ? {'width':'100%'}: {}">
                      <img :src="item.imgUrl">
                  </div>
                  <div class="right" v-if="!($route.query.id == 18 || $route.query.id == 17 || $route.query.id == 16)">
                      <div class="name">{{item.title}}</div>
                      <div class="desc">
                          <div v-for="(label, index) in item.description" :key="'name_'+currentId+'_'+index">{{label}}</div>
                      </div>
                  </div>
                  <div class="clear"></div>
              </div>
          </div>
      </div>
        <right-action :isShowTopBtn="isShowTopBtn"></right-action>
      <footer-common :isShowTopBtn="isShowTopBtn"> </footer-common>
    </div>
</template>

<script>
import headerCommon from '../common/headerCommon';
import footerCommon from '../common/footerCommon';
import $ from 'jquery';
import rightAction from '../common/rightIcon';
export default {
    name: "infoService",
    data () {
        return {
            titleList: [
                {
                    id: 1,
                    value: '工作看板'
                },
                {
                    id: 2,
                    value: '报修服务'
                },
                {
                    id: 3,
                    value: '工作目标计划'
                },
                {
                    id: 4,
                    value: '项目管理'
                },
                {
                    id: 5,
                    value: '需求管理'
                },
                {
                    id: 6,
                    value: '任务管理'
                },
                {
                    id: 7,
                    value: '运维巡检'
                },
                {
                    id: 8,
                    value: '等级医院评审'
                },
                {
                    id: 9,
                    value: '电子病历评级'
                },
                {
                    id: 10,
                    value: '合同管理'
                },
                {
                    id: 11,
                    value: '工作汇报'
                },
                {
                    id: 12,
                    value: '资料管理'
                },
                {
                    id: 13,
                    value: '值班管理'
                },
                {
                    id: 14,
                    value: '会议管理'
                },
                {
                    id: 15,
                    value: '请休假管理'
                },
                {
                    id: 16,
                    value: '制度管理'
                },
                {
                    id: 17,
                    value: '考勤管理'
                },
                {
                    id: 18,
                    value: '全文检索'
                }
            ],
            itemList: [
                {
                    order: '一、',
                    title: '工作看板',
                    description: '让管理者、项目负责人、参与者对团队和个人工作状态了如指掌',
                    imgUrl: require("../../assets/images/infoService/1/main.png"),
                    content: [
                        {
                            title: '01.项目管理',
                            description: ['随时查看项目进度，', '及时发现和规避风险。'],
                            imgUrl: require("../../assets/images/infoService/1/one.png")
                        },
                        {
                            title: '02.日常工作',
                            description: ["从值班、考勤、日志，到任务、关注、代办，","全面管理日常工作。"],
                            imgUrl: require("../../assets/images/infoService/1/two.png")
                        },
                        {
                            title: '03.报修统计',
                            description: ['闭环管理，','提供全方位、多维度统计功能。'],
                            imgUrl: require("../../assets/images/infoService/1/three.png")
                        },
                        {
                            title: '04.工作计划',
                            description: ['为重大事件和任务建立工作目标和计划，', '智能管理、甘特图显示。'],
                            imgUrl: require("../../assets/images/infoService/1/four.png")
                        }
                    ]
                },
                {
                    order: '二、',
                    title: '报修服务',
                    description: '智能报修运维平台， 高效便捷',
                    imgUrl: require("../../assets/images/infoService/2/main.png"),
                    content: [
                        {
                            title: '01.多种报修方式',
                            description: ['电话、微信、APP均可报修。'],
                            imgUrl: require("../../assets/images/infoService/2/one.png")
                        },
                        {
                            title: '02.快速创建工单',
                            description: ['来电弹屏、摘机建单，','自动获取来电信息，自动录音，','输入关键字即可完成建单。'],
                            imgUrl: require("../../assets/images/infoService/2/two.png")
                        },
                        {
                            title: '03.实时跟踪，催办提醒',
                            description: ['状态实时可查，', '集成短信、推送、电话等通知方式，','派单后灵活操作。'],
                            imgUrl: require("../../assets/images/infoService/2/three.png")
                        },
                        {
                            title: '04.知识库',
                            description: ['汇聚经验，为维修提供支撑。'],
                            imgUrl: require("../../assets/images/infoService/2/four.png")
                        },
                        {
                            title: '05.统计分析，持续改进',
                            description: ['实时数据统计，','工作量统计，','报修类别统计，','为持续改进、考核提供数据支撑。'],
                            imgUrl: require("../../assets/images/infoService/2/five.png")
                        }
                    ]
                },
                {
                    order: '三、',
                    title: '工作目标计划',
                    description: '聚焦重点工作，按时保质完成',
                    imgUrl: require("../../assets/images/infoService/3/main.png"),
                    content: [
                        {
                            title: '01.计划部署',
                            description: ['制定目标详细信息，','以任务单形式落实，','可关联会议。'],
                            imgUrl: require("../../assets/images/infoService/3/one.png")
                        },
                        {
                            title: '02.智能管理',
                            description: ['实时进度监控，','计划有进展或变动时，','系统自动提醒相关人员。'],
                            imgUrl: require("../../assets/images/infoService/3/two.png")
                        },
                        {
                            title: '03.甘特图显示',
                            description: ['任务单自行排序，','可下设子任务，', '可按日/周/月进行显示，','逾期提醒。'],
                            imgUrl: require("../../assets/images/infoService/3/three.png")
                        }
                    ]
                },
                {
                    order: '四、',
                    title: '项目管理',
                    description: '管理项目其实很简单',
                    imgUrl: require("../../assets/images/infoService/4/main.png"),
                    content: [
                        {
                            title: '01.全生命周期管理',
                            description: ['覆盖规划设计、部署实施、服务运营、持续改进、监督管理等全生命周期。'],
                            imgUrl: require("../../assets/images/infoService/4/one.png")
                        },
                        {
                            title: '02.深度自定义',
                            description: ['项目阶段模板自定义，','任务单类型/标签自定义，','业务标签自定义。'],
                            imgUrl: require("../../assets/images/infoService/4/two.png")
                        },
                        {
                            title: '03.过程全纪录',
                            description: ['记录需求进展/任务单变更，','记录会议/问题/资料等。'],
                            imgUrl: require("../../assets/images/infoService/4/three.png")
                        },
                        {
                            title: '04.事件全关联',
                            description: ['关联工作计划、会议、任务、需求、资料，','事件分类汇总，快速获取。'],
                            imgUrl: require("../../assets/images/infoService/4/four.png")
                        }
                    ]
                },
                {
                    order: '五、',
                    title: '需求管理',
                    description: '实施有依据，交付不走样',
                    imgUrl: require("../../assets/images/infoService/5/main.png"),
                    content: [
                        {
                            title: '01.用户需求详细记录',
                            description: ['记录需求名称、提出科室、提出人，','记录提出时间、需求描述等，','保证需求完整性、准确性。'],
                            imgUrl: require("../../assets/images/infoService/5/one.png")
                        },
                        {
                            title: '02.需求建设全程管理',
                            description: ['覆盖需求建设全过程，','各阶段分别制定负责人，','进度实施可查。'],
                            imgUrl: require("../../assets/images/infoService/5/two.png")
                        },
                        {
                            title: '03.打通需求、建设、实施方',
                            description: ['对内加强信息交互，','对外强化对第三方的管理与合作。'],
                            imgUrl: require("../../assets/images/infoService/5/three.png")
                        }
                    ]
                },
                {
                    order: '六、',
                    title: '任务管理',
                    description: '凡事有交代、件件有着落、事事有回应',
                    imgUrl: require("../../assets/images/infoService/6/main.png"),
                    content: [
                        {
                            title: '01.任务分配清晰明确',
                            description: ['多场景快速分配，','设置负责人、起止时间、优先级等信息。'],
                            imgUrl: require("../../assets/images/infoService/6/one.png")
                        },
                        {
                            title: '02.协同合作提高效率',
                            description: ['任务分解成若干子任务，','子任务分别指派负责人，','让团队成员充分发挥自身优势，协作完成。'],
                            imgUrl: require("../../assets/images/infoService/6/two.png")
                        },
                        {
                            title: '03.操作记录有据可查',
                            description: ['新增进展、编辑任务、重新指定责任人等操作，','系统均有所记录，全部留痕。'],
                            imgUrl: require("../../assets/images/infoService/6/three.png")
                        }
                    ]
                },
                {
                    order: '七、',
                    title: '运维巡检',
                    description: '移动巡检，更加便捷',
                    imgUrl: require("../../assets/images/infoService/7/main.png"),
                    content: [
                        {
                            title: '01.日常巡检全覆盖',
                            description: ['运维内容自定义，','可定义机房、设备、系统与软件等的巡检工作，',' 全面覆盖日常巡检工作。'],
                            imgUrl: require("../../assets/images/infoService/7/one.png")
                        },
                        {
                            title: '02.巡检工作更便捷',
                            description: ['实时填写巡检报告，','输入关键信息或简单勾选即可，','对故障进行提示。'],
                            imgUrl: require("../../assets/images/infoService/7/two.png")
                        },
                        {
                            title: '03.机房出入审批制',
                            description: ['进入机房需扫码登记，','出入信息详细记录，','确保设备与信息安全。'],
                            imgUrl: require("../../assets/images/infoService/7/three.png")
                        }
                    ]
                },
                {
                    order: '八、',
                    title: '等级医院评审',
                    description: '无纸化台账，有序化执行',
                    imgUrl: require("../../assets/images/infoService/8/main.png"),
                    content: [
                        {
                            title: '01.责任划分明确',
                            description: ['评审条款指定责任科室、责任人，','工作进展实时可查，整体把控。'],
                            imgUrl: require("../../assets/images/infoService/8/one.png")
                        },
                        {
                            title: '02.台账自动生成',
                            description: ['评审标准与日常工作紧密结合，','台账自动生成，','一键导出打印。'],
                            imgUrl: require("../../assets/images/infoService/8/two.png")
                        },
                        {
                            title: '03.等级自评',
                            description: ['简单勾选、即可输出评审结果，','便于自我监督和管理。'],
                            imgUrl: require("../../assets/images/infoService/8/three.png")
                        }
                    ]
                },
                {
                    order: '九、',
                    title: '电子病历评级',
                    description: '协助完成电子病历评级准备工作',
                    imgUrl: require("../../assets/images/infoService/9/main.png"),
                    content: [
                        {
                            title: '01.责任划分明确',
                            description: ['创建评级任务并进行分解，','通过团队合作完成指定目标，','任务进展情况实时可查，整体把控。'],
                            imgUrl: require("../../assets/images/infoService/9/one.png")
                        },
                        {
                            title: '02.实证材料管理',
                            description: ['一次维护，多次复用，','一键导出指定级别的实证材料，','格式符合上报要求。'],
                            imgUrl: require("../../assets/images/infoService/9/two.png")
                        },
                        {
                            title: '03.系统自动评分',
                            description: ['数据填报实时评分，','对未达标项及缺陷内容进行提示，','便于数据分析和修正。'],
                            imgUrl: require("../../assets/images/infoService/9/three.png")
                        }
                    ]
                },
                {
                    order: '十、',
                    title: '合同管理',
                    description: '合同用时方恨少，管理不好隐患多',
                    imgUrl: require("../../assets/images/infoService/10/main.png"),
                    content: [
                        {
                            title: '01.合同管理',
                            description: ['管理各种合同类型，','多种付款计划模板，','合同文本文件批量导入。'],
                            imgUrl: require("../../assets/images/infoService/10/one.png")
                        },
                        {
                            title: '02.智能识别',
                            description: ['OCR智能识别，','读取合同信息，','大幅提升工作效率。'],
                            imgUrl: require("../../assets/images/infoService/10/two.png")
                        },
                        {
                            title: '03.收付款管理',
                            description: ['付款计划自动生成，日历方式展现，','自动发送收付款提醒,年度预算自动生成。'],
                            imgUrl: require("../../assets/images/infoService/10/three.png")
                        }
                    ]
                },
                {
                    order: '十一、',
                    title: '工作汇报',
                    description: '当日工作自动识别，可跟踪查看',
                    imgUrl: require("../../assets/images/infoService/11/main.png"),
                    content: [
                        {
                            title: '01.丰富的汇报形式',
                            description: ['日报/月报/周报/每日交班，','个人工作汇报/部门工作汇报，','工作交接无盲点。'],
                            imgUrl: require("../../assets/images/infoService/11/one.png")
                        },
                        {
                            title: '02.一键引入',
                            description: ['需求单/报修单/任务单/会议一键导入，', '管理者点击超链接深入了解。'],
                            imgUrl: require("../../assets/images/infoService/11/two.png")
                        },
                        {
                            title: '03.数据统计',
                            description: ['快速了解科室人员日志提交情况，一目了然。'],
                            imgUrl: require("../../assets/images/infoService/11/three.png")
                        }
                    ]
                },
                {
                    order: '十二、',
                    title: '资料管理',
                    description: '知识共享，经验传承，快速查阅',
                    imgUrl: require("../../assets/images/infoService/12/main.png"),
                    content: [
                        {
                            title: '01.文件多版本管理',
                            description: ['文件可记录演变过程，方便版本对比及追溯。'],
                            imgUrl: require("../../assets/images/infoService/12/one.png")
                        },
                        {
                            title: '02.目录自定义',
                            description: ['任意层级的目录均可自定义，','可见范围灵活设置，一键分享。'],
                            imgUrl: require("../../assets/images/infoService/12/two.png")
                        },
                        {
                            title: '03.在线预览',
                            description: ['附件无需下载，在线预览，','支持多种格式，','关键字检索，快速定位。'],
                            imgUrl: require("../../assets/images/infoService/12/three.png")
                        }
                    ]
                },
                {
                    order: '十三、',
                    title: '值班管理',
                    description: '灵活排班，功能丰富',
                    imgUrl: require("../../assets/images/infoService/13/main.png"),
                    content: [
                        {
                            title: '01.智能排班',
                            description: ['多种排班方式，可批量排班。'],
                            imgUrl: require("../../assets/images/infoService/13/one.png")
                        },
                        {
                            title: '02.值班加班日志',
                            description: ['记录值班、加班人员的工作情况，','统计值班、加班时长等信息。'],
                            imgUrl: require("../../assets/images/infoService/13/two.png")
                        }
                    ]
                },
                {
                    order: '十四、',
                    title: '会议管理',
                    description: '让会议更高效、更规范',
                    imgUrl: require("../../assets/images/infoService/14/main.png"),
                    content: [
                        {
                            title: '01.会议记录',
                            description: ['会议安排、会议纪要，上传音频视频文件。'],
                            imgUrl: require("../../assets/images/infoService/14/one.png")
                        },
                        {
                            title: '02.扫码签到',
                            description: ['微信/APP扫码签到，管理更高效。'],
                            imgUrl: require("../../assets/images/infoService/14/two.png")
                        },
                        {
                            title: '03.会议室管理',
                            description: ['通过会议预约安排，直观显示会议室占用情况，','确保会议顺利召开及资源有效利用。'],
                            imgUrl: require("../../assets/images/infoService/14/three.png")
                        }
                    ]
                },
                {
                    order: '十五、',
                    title: '请休假管理',
                    description: '具有信息中心特色的请休假管理',
                    imgUrl: require("../../assets/images/infoService/15/main.png"),
                    content: [
                        {
                            title: '01.假期统计，请假安排',
                            description: [],
                            imgUrl: require("../../assets/images/infoService/15/one.png")
                        },
                        {
                            title: '02.节假日自定义',
                            description: [],
                            imgUrl: require("../../assets/images/infoService/15/two.png")
                        },
                        {
                            title: '03.请休假管理',
                            description: [],
                            imgUrl: require("../../assets/images/infoService/15/three.png")
                        }
                    ]
                },
                {
                    order: '十六、',
                    title: '制度管理',
                    description: '',
                    imgUrl: require("../../assets/images/infoService/16/main.png"),
                    content: [
                        {
                            title: '',
                            description: [],
                            imgUrl: require("../../assets/images/infoService/16/one.png")
                        }
                    ]
                },
                {
                    order: '十七、',
                    title: '考勤管理',
                    description: '',
                    imgUrl: require("../../assets/images/infoService/17/main.png"),
                    content: [
                        {
                            title: '',
                            description: [],
                            imgUrl: require("../../assets/images/infoService/17/one.png")
                        }
                    ]
                },
                {
                    order: '十八、',
                    title: '全文检索',
                    description: '',
                    imgUrl: require("../../assets/images/infoService/18/main.png"),
                    content: [
                        {
                            title: '',
                            description: [],
                            imgUrl: require("../../assets/images/infoService/18/one.png")
                        }
                    ]
                }
            ],
            typeNameList: [
                {
                    name: '综合概览',
                    list: [
                        {
                            id: 1,
                            value: '工作看板'
                        },
                        {
                            id: 18,
                            value: '全文检索'
                        },
                        {
                            id: 6,
                            value: '任务管理'
                        }
                    ]
                },
                {
                    name: '项目管理',
                    list: [
                        {
                            id: 4,
                            value: '项目管理'
                        },
                        {
                            id: 3,
                            value: '工作目标计划'
                        }
                    ]
                },
                {
                    name: '运维管理',
                    list: [
                        {
                            id: 2,
                            value: '报修服务'
                        },
                        {
                            id: 7,
                            value: '运维巡检'
                        }
                    ]
                },
                {
                    name: '评级评审',
                    list: [
                        {
                            id: 8,
                            value: '等级医院评审'
                        },
                        {
                            id: 9,
                            value: '电子病历评级'
                        }
                    ]
                },
                {
                    name: '综合管理',
                    list: [
                        {
                            id: 10,
                            value: '合同管理'
                        },
                        {
                            id: 12,
                            value: '资料管理'
                        },
                        {
                            id: 5,
                            value: '需求管理'
                        }
                    ]
                },
                {
                    name: '日常工作',
                    list: [
                        {
                            id: 11,
                            value: '工作汇报'
                        },
                        {
                            id: 13,
                            value: '值班管理'
                        },
                        {
                            id: 14,
                            value: '会议管理'
                        },
                        {
                            id: 15,
                            value: '请休假管理'
                        },
                        {
                            id: 16,
                            value: '制度管理'
                        },
                        {
                            id: 17,
                            value: '考勤管理'
                        }
                    ]
                }
            ],
            currentId: 8,
            isShowAll: false,
            isShowTopBtn: false,
            isFixed: false,
            screenWidth: 0,
            showPopup: false
            // activeKey: this.$route.query.id-1
        };
    },
    components: {
        headerCommon,
        footerCommon,
        rightAction
    },
    methods: {
        handleClick (id) {
            this.showPopup = false;
            this.$router.push({
                path: '/infoService',
                query: {
                    id: id
                }
            });
            $('body,html').animate({scrollTop: 0}, 500);
        },
        handleSelect (val) {
            let id = val.split("_")[1];
            this.handleClick(id);
        },
        popupHandle () {
            // console.log(12)
            this.showPopup = true;
        },
        menuClick () {
            this.isShowAll = !this.isShowAll;
        },
        listTitleStyle (list) {
            for (let i in list) {
                if (list[i].id === Number(this.$route.query.id)) {
                    return 'active';
                }
            }
        },
        handleScroll () {
            let that = this;
            this.$nextTick(()=>{
                // 设备/屏幕高度
                let scrollTop = document.documentElement.scrollTop; // div 到头部的距离
                if (scrollTop >0) {
                    that.isFixed = true;
                    that.isShowTopBtn = true;
                } else {
                    that.isFixed = false;
                    that.isShowTopBtn = false;
                }
            });
        },
        mouseenterHandle () {
            this.isShowAll = true;
        },
        mouseleaveHandle () {
            this.isShowAll = false;
        }
    },
    mounted() {
        this.currentId = this.$route.query.id -1;
        let that = this;
        this.$nextTick(()=> {
            that.screenWidth = document.documentElement.clientWidth;
        });
        $(window).bind('resize',function () {
            that.screenWidth = document.documentElement.clientWidth;
        });
        window.addEventListener('scroll',this.handleScroll);
    },
    updated () {
        this.currentId = this.$route.query.id -1;
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/detailPage/infoService.vue